import { Component, ViewChild, inject } from '@angular/core';
import { BoDialogComponent } from '@3ddv/software-division-components/backoffice/dialog';
import { ButtonComponent } from '@3ddv/software-division-components/generic/button';
import { BrnDialogRef } from '@spartan-ng/brain/dialog';
import {
  GsEventSelectorComponent,
  SelectionMeta,
} from 'src/app/shared/features/event-selector/gs-event-selector.component';
import { UtilsService } from '../../../services/utils.service';
import { DialogCloseReason } from '../../../layout/dialog/app-dialog.service';
import { Upsell } from '../../models/upsell.model';
import { UpsellService } from '../../services/upsell.service';

import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.css'],
  imports: [
    BoDialogComponent,
    ButtonComponent,
    FormsModule,
    GsEventSelectorComponent,
  ],
})
export class CreateComponent {
  private dialogRef = inject<BrnDialogRef<DialogCloseReason>>(BrnDialogRef);
  private upsellService = inject(UpsellService);
  private utils = inject(UtilsService);

  @ViewChild(GsEventSelectorComponent)
  eventSelector: GsEventSelectorComponent;

  public item: Upsell;
  public postImage: File;
  public imagePreview: any;
  public selectedEventIds: number[] = [];
  public isAllEventsSelected = false;
  public hashValidator = {
    name: false,
    description: false,
    buyerTypeName: false,
    buyerTypeId: false,
    price: false,
  };

  constructor() {
    this.item = {
      id: 0,
      active: true,
      name: '',
      description: '',
      urlImage: '',
      buyerTypeId: 0,
      buyerTypeName: '',
      price: 0,
    };
    this.imagePreview = null;
  }

  public onDismiss(reason: DialogCloseReason) {
    this.dialogRef.close(reason);
  }

  public onFileChange(event) {
    this.postImage = event.target.files[0];
    var reader = new FileReader();
    this.imagePreview = null;
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = _event => {
      this.imagePreview = reader.result;
    };
  }

  public onConfirm() {
    let hasError = this.checkInputs(this.item);
    if (hasError) return;
    this.upsellService
      .create$(this.item, this.postImage, this.selectedEventIds ?? [])
      .subscribe({
        next: response => {
          this.onDismiss('success');
        },
        error: err => {
          console.log(err);
        },
      });
  }

  private checkInputs(instance: Upsell): boolean {
    let hasErrors = false;
    Object.keys(this.hashValidator).forEach(value => {
      this.hashValidator[value] = false;
    });
    if (this.utils.isEmpty(instance.buyerTypeName)) {
      this.hashValidator.buyerTypeName = true;
      hasErrors = true;
    }
    if (this.utils.isEmpty(instance.name)) {
      this.hashValidator.name = true;
      hasErrors = true;
    }
    if (this.utils.isEmpty(instance.description)) {
      this.hashValidator.description = true;
      hasErrors = true;
    }
    if (
      !this.utils.onlyHasNumbers(instance.buyerTypeId) ||
      instance.buyerTypeId === 0
    ) {
      this.hashValidator.buyerTypeId = true;
      hasErrors = true;
    }
    if (instance.price <= 0) {
      this.hashValidator.price = true;
      hasErrors = true;
    }

    return hasErrors;
  }

  public onEventSelectionChange(ids: number[]) {
    this.selectedEventIds = ids;
  }

  public onEventSelectionMeta(meta: SelectionMeta) {
    this.isAllEventsSelected = meta.isAllSelected;
  }

  public onSelectAllEventsChange(event: any) {
    this.eventSelector.selectAll(event.target.checked);
  }
}
